import Model, { executeMutation, GqlError, ID, IsoDateTime, JsonObject, MODEL_LEVEL } from 'src/models/Model'

export const CUSTOM_EVENT_PREFIX = '_custom_'

export const ACTION_TYPES = {
  GENERATE_VOUCHERS: 'generate_vouchers'
}
ACTION_TYPES.ALL = Object.values(ACTION_TYPES)

export const STATES = {
  NEW: 'new',
  RUNNING_ACTIONS: 'running-actions',
  READY_TO_RUN: 'ready-to-run',
  CREATING_ACTIONS: 'creating-actions',
  SCHEDULING_ACTIONS: 'scheduling-actions',
  COMPLETED: 'completed',
  COMPLETED_WITH_ERRORS: 'completed-with-errors',
  ERRORED: 'errored'
}

export const RUNNING_STATES = [STATES.RUNNING_ACTIONS, STATES.CREATING_ACTIONS, STATES.SCHEDULING_ACTIONS]
export const COMPLETED_STATES = [STATES.COMPLETED, STATES.COMPLETED_WITH_ERRORS, STATES.ERRORED]

export default class CustomerioSegmentTask extends Model {
  static name = 'CustomerioSegmentTask'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        output: true
      },
      name: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: false
      },
      state: {
        type: String,
        output: true
      },
      customerioSegmentId: {
        type: ID,
        required: true
      },
      customerioSegmentName: {
        type: String,
        required: false,
        output: true
      },
      actionType: {
        type: String,
        required: true,
        default: null
      },
      actionArguments: {
        type: JsonObject,
        required: true,
        default: () => ({})
      },
      batchStartedAt: {
        type: IsoDateTime,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        output: true
      }
    }

    this.mutations = {
      executeCustomerioSegmentTask: {
        arguments: {
          id: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }

    this.computed = {
      canExecute () {
        return this.state === STATES.READY_TO_RUN
      },
      isRunning () {
        return _.includes(RUNNING_STATES, this.state)
      },
      isCompleted () {
        return _.includes(COMPLETED_STATES, this.state)
      }
    }
  }

  async executeCustomerioSegmentTask () {
    const results = await executeMutation(
      'executeCustomerioSegmentTask',
      { id: this.id },
      {
        errors: {
          structure: {
            code: true,
            description: true
          }
        },
        success: true
      }
    )

    return results
  }
}
